export default __webpack_public_path__ + "static/media/3rd.c81c7cfb.svg";